<template lang="html">
  <div class="main-container">
    <div class="msc-title">Manage School Info</div>
    <edit-school-info :schoolTitle="false" />
  </div>
</template>

<script>
  import editSchoolInfo from './../../individualSchoolTabs/editSchoolInfo.vue';

  export default {
    data() {
      return {};
    },
    components: {
      editSchoolInfo,
    },
  };
</script>

<style scoped lang="stylus">
  .main-container
    margin: 2rem 8rem 2rem 2rem
    padding-top: 1rem
    @media (max-width: 1024px)
      margin: 2rem
  .msc-title
    height: 39px
    font-size: 32px
    color: #595959
    font-weight: 600
</style>



// WEBPACK FOOTER //
// adminPortalSchoolInfo.vue?02d9d4bc